import { useState } from "react";
import { AGENDA } from "@/data/siteData";

export const Agenda = () => {
  const [active, setActive] = useState(0);
  const day = AGENDA[active];

  return (
    <section id="agenda" data-testid="agenda-section" className="border-b border-zinc-200 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-12 gap-6 md:gap-10 items-end mb-10 md:mb-14">
          <div className="col-span-12 md:col-span-6">
            <div className="overline text-[#FF2A00] mb-4">/ 03 — Agenda</div>
            <h2 className="font-display text-4xl md:text-5xl uppercase tracking-tight">
              Two Days.
              <br />
              Zero filler.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-6 md:text-right">
          </div>
        </div>

        {/* Day Tabs */}
        <div className="flex flex-wrap gap-0 border border-zinc-200 border-b-0">
          {AGENDA.map((d, i) => (
            <button
              key={d.day}
              data-testid={`agenda-tab-${i}`}
              onClick={() => setActive(i)}
              className={`flex-1 min-w-[180px] text-left p-5 border-r border-zinc-200 last:border-r-0 transition-colors ${
                active === i
                  ? "bg-[#002FA7] text-white"
                  : "bg-white text-zinc-800 hover:bg-zinc-50"
              }`}
            >
              <div className={`overline ${active === i ? "text-white/70" : "text-zinc-500"}`}>
                {d.day}
              </div>
              <div className="font-display text-lg md:text-xl mt-1 tracking-tight">
                {d.theme}
              </div>
              {d.date && (
                <div className={`text-xs mt-1 ${active === i ? "text-white/80" : "text-zinc-500"}`}>
                  {d.date}
                </div>
              )}
            </button>
          ))}
        </div>

        {/* Sessions table */}
        <div className="border border-zinc-200 border-t-0">
          <div className="hidden md:grid grid-cols-12 bg-zinc-50 border-b border-zinc-200 overline text-zinc-500">
            <div className="col-span-2 p-4 border-r border-zinc-200">Time</div>
            <div className="col-span-6 p-4 border-r border-zinc-200">Session</div>
            <div className="col-span-2 p-4 border-r border-zinc-200">Speaker</div>
            <div className="col-span-2 p-4">Track</div>
          </div>
          {day.sessions.map((s, i) => (
            <div
              key={i}
              data-testid={`agenda-session-${active}-${i}`}
              className="grid grid-cols-12 border-b border-zinc-100 last:border-b-0 hover:bg-zinc-50 transition-colors"
            >
              <div className="col-span-3 md:col-span-2 p-4 md:p-5 border-r border-zinc-100 font-mono text-sm text-[#002FA7]">
                {s.time}
              </div>
              <div className="col-span-9 md:col-span-6 p-4 md:p-5 md:border-r border-zinc-100">
                <div className="font-display text-base md:text-lg tracking-tight">
                  {s.title}
                </div>
                <div className="md:hidden overline text-zinc-500 mt-2">
                  {s.speaker} · {s.track}
                </div>
              </div>
              <div className="hidden md:block col-span-2 p-5 border-r border-zinc-100 text-sm text-zinc-700">
                {s.speaker}
              </div>
              <div className="hidden md:block col-span-2 p-5 overline text-zinc-500">
                {s.track}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Agenda;
